import produce from "immer";
import pullAllBy from "lodash/pullAllBy";
import { NotificationsState } from "../";

export interface RemoveNotificationAction {
  type: "removeNotification";
  notificationKey: string;
}

export const removeNotification = (
  state: NotificationsState,
  action: RemoveNotificationAction
): NotificationsState => {
  return produce(state, (draftState) => {
    const { notificationKey } = action;

    pullAllBy(draftState.notifications, [{ key: notificationKey }], "key");
  });
};
